// extracted by css-extract-rspack-plugin
export default {"selectedUserView":"src-modules-auth-pages-LoginPage-views-SelectedUserView-SelectedUserView-module__selectedUserView-xRNAHt","content":"src-modules-auth-pages-LoginPage-views-SelectedUserView-SelectedUserView-module__content-Rxyeb0"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"selectedUserView\":\"src-modules-auth-pages-LoginPage-views-SelectedUserView-SelectedUserView-module__selectedUserView-xRNAHt\",\"content\":\"src-modules-auth-pages-LoginPage-views-SelectedUserView-SelectedUserView-module__content-Rxyeb0\"}";
        // 1793873547402
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  